import { FC } from 'react'

import * as Icons from '~/src/components/generic/PhosphorIcons/iconRegistry'
import { IconPropsType, IconProps } from '~/src/components/generic/PhosphorIcons/types'

const Icon: FC<IconProps> = ({
  name,
  color,
  size,
  weight,
  mirrored,

  ...rest
}) => {
  // eslint-disable-next-line import/namespace
  const IconComponent = Icons[name] as FC<IconPropsType>

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in registry`)

    return null
  }

  return (
    <IconComponent
      color={color}
      mirrored={mirrored}
      size={size}
      weight={weight}
      {...rest}
    />
  )
}

export default Icon
